<script setup>
import WebsitePricingTiers from "@/components/website/agency/partials/ui/WebsitePricingTiers.vue";
import ProductPrice from "@/components/website/agency/partials/ui/ProductPrice.vue";
import PricingTiers from "@/components/website/agency/partials/ui/PricingTiers.vue";
import ProductInclusions from "@/components/website/agency/partials/ui/ProductInclusions.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import CouponApplied from "@/components/website/agency/partials/ui/CouponApplied.vue";

const store = useStore();
const showPricingTiers = ref(false);
const loading = computed(() => store.getters['agencyWebsite/loading']);

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  alternateHasDiscount: {
    type: Boolean,
    required: true,
  },
  inclusions: {
    type: Array,
    required: true,
  },
  recommended: {
    type: Boolean,
    default: false,
  },
});

const handleSubmit = async() => {
  await store.dispatch('agencyWebsite/create', !!props.product.addon);
}
</script>

<template>
  <div class="tw-flex tw-flex-col tw-max-w-[462px] tw-w-full">
    <div
      v-if="recommended"
      class="tw-bg-primary tw-border-primary tw-rounded-t-2xl tw-py-3 tw-text-white tw-flex tw-justify-center tw-font-bold tw-text-base"
    >
      Recommended
    </div>
    <div
      v-if="!showPricingTiers"
      class="tw-text-neutral-900 tw-text-base tw-border-2 tw-flex tw-flex-col tw-gap-y-8 tw-px-8 tw-pb-8 tw-pt-20 tw-flex-grow"
      :class="[recommended ? 'tw-border-primary tw-rounded-b-2xl tw-bg-primary-100/25' : 'tw-border-neutral-300 tw-rounded-2xl tw-mt-12']"
    >
      <div class="tw-text-2xl tw-font-bold tw-leading-13 tw-flex-grow-0">
        <slot name="product-name" />
      </div>

      <CouponApplied v-if="product.discountPrice" />

      <ProductPrice
        :product="product"
        :recommended="recommended"
      />

      <span>
        <slot name="description" />
      </span>

      <PricingTiers
        :product="product"
        @show-tiers="showPricingTiers = true"
      />

      <ProductInclusions :inclusions="inclusions" />

      <DefaultButton
        class="tw-mt-4"
        :variant="recommended ? 'primary' : 'primary-inverted'"
        :disabled="loading"
        @click="handleSubmit"
      >
        Get Started
      </DefaultButton>

      <slot name="additional-info" />
    </div>

    <WebsitePricingTiers
      v-else
      :product="product"
      :addon="product.addon"
      :recommended="recommended"
      @back="showPricingTiers = false"
    />
  </div>
</template>

